import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import {
  ManagerFiltersActionTypes,
  ManagerSetAllDefaultFilters
} from './actions';
import { ManagerActionTypes } from '../manager/actions';
import {
  selectManagerFiltersUnsavedDefaultsState,
  SharedState
} from '../reducer';

@Injectable()
export class ManagerFilterEffects {
  public STORAGE_KEY = 'manager-default-selection-state';

  @Effect()
  public loadManagerDefaultSelectionFilterState$: Observable<ManagerSetAllDefaultFilters> = this.actions$
    .pipe(ofType(ManagerActionTypes.LoadManager))
    .pipe(
      map(() => {
        const state = JSON.parse(localStorage.getItem(this.STORAGE_KEY));
        return new ManagerSetAllDefaultFilters(state);
      })
    );

  @Effect({ dispatch: false })
  public saveManagerDefaultSelectionFilterState$: Observable<void> = this.actions$
    .pipe(
      ofType(ManagerFiltersActionTypes.SetAllUnsavedAsDefault),
      withLatestFrom(
        this.store.pipe(select(selectManagerFiltersUnsavedDefaultsState))
      )
    )
    .pipe(
      map(([, filters]) => {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filters));
      })
    );

  constructor(private actions$: Actions, private store: Store<SharedState>) {}
}
